import { Storybook } from "@tento-ui/ui/storybook";
import { DshTurnProse } from "./prose";

export class DshTurnProseStoryBook extends Storybook.Default {
  title(): string {
    return "Turn dsh · prose";
  }

  examples(): Storybook.Example[] {
    return [
      {
        title: "A paragraph — no marks, nothing changes",
        render: () =>
          DshTurnProse.makeWith({
            text:
              "Prompt path confirmed. Let me round-trip the render registry file the same way, since the shell UI hot-loads through a separate status channel.",
          }),
      },
      {
        title: "Inline code — the 57% case, and the reason for all of this",
        render: () =>
          DshTurnProse.makeWith({
            text:
              "**Prompt hot-reload**: a comment tweak to `prompt.tsh` was picked up within a second (`applied`, generation 8 → 9).",
          }),
      },
      {
        title: "The fixture's reply — the 16px seam across four blocks",
        render: () =>
          DshTurnProse.makeWith({
            text: [
              "Fixed, and the cause was not where the symptom was. `visibleRecords` "
                + "merged every lane into one list ordered by `seq`, which Rust computes "
                + "**per pane** — so `ctl` numbering 1–14 and `news` numbering 1–114 "
                + "interleaved, and `closeTurn()` shredded one lane's turn across the "
                + "other's prompts.",
              "The merge is now k-way over already-ordered lane streams, keyed on a "
                + "parsed timestamp rather than a compared string. Two measured hazards "
                + "made that necessary:",
              "- 34,392 records carry microsecond stamps and 38 carry milliseconds, so a "
                + "string compare puts `.200Z` after `.200437Z`;\n"
                + "- four records in session `14925` go backwards *inside* their own "
                + "lane, where `seq` is authoritative and the clock is not.",
              "Clamping each stamp to at least its predecessor's answers both at once: a "
                + "lane keeps its own order no matter what its clock did, and only the "
                + "interleave between lanes reads the time.",
            ].join("\n\n"),
          }),
      },
      {
        title: "Headings — two steps above the body, then the body size",
        render: () =>
          DshTurnProse.makeWith({
            text:
              "# What changed\n\nThe merge is k-way now.\n\n## Why\n\n`seq` is per-pane.\n\n### The regression fixture\n\nSession `52738`.",
          }),
      },
      {
        title: "A fenced block — scrolls inside its own card",
        render: () =>
          DshTurnProse.makeWith({
            text:
              "The clamp, in full:\n\n```rust\nfn lane_clock(lane: &Lane) -> Vec<i64> {\n    let mut last = 0;\n    lane.records.iter().map(|r| { last = r.at.max(last); last }).collect()\n}\n```\n\nOne pass, no allocation past the output.",
          }),
      },
      {
        title: "A table — the docs' own table style, adopted not redrawn",
        render: () =>
          DshTurnProse.makeWith({
            text:
              "| lane | records | out of order |\n| --- | --- | --- |\n| ctl | 14 | 0 |\n| news | 114 | 4 |",
          }),
      },
      {
        title: "Empty",
        render: () => DshTurnProse.makeWith({ text: "" }),
      },
    ];
  }
}
